import Gallery from "./Gallery";

const ColourfulCoral = () => (
  <Gallery imageNames={["colourful coral-01.png", "colourful coral-02.png"]} />
);
export default ColourfulCoral;
